import {FlowData, ProductInstance} from "./types.ts";

export type submitFormFunction = (customerId: string, productInstanceId: number, flowData: FlowData) => Promise<string>;

export type ProductErrorFlow = (props: { product: ProductInstance, submitFunction: submitFormFunction }) => React.JSX.Element;

export type Tech = 'Fiber' | 'Coax' | 'Other';

export const ProductId = {
    EnergiFynProductId: 1009,
    EniigProductId: 1006,
    EwiiProductId: 1007,
    FbsaProductId: 1005,
    FibiaProductId: 1008,
    GlobalConnectProductId: 1013,
    NordEnergiProductId: 1011,
    ThyMorsProductId: 1012,
    RaaFiberProductId: 1000,
    RahProductId: 1015,
    SefProductId: 1014,
    SydEnergiProductId: 1010,
}

export const TechValues = {
    Fiber: 'Fiber',
    Coax: 'Coax',
    Dsl: 'Dsl',
    MBB: 'TDC-MBB',
    Other: 'Other',
};

export const ConnectionTypeValues = {
    wifi: 'wifi',
    cable: 'kablet',
    both: 'begge',
}

export type Forms = {
    [key in Tech]: ProductErrorFlow;
};

export type Option = {
    display_name: string;
    name: string;
    forms: Forms;
};

export type Options = { [key: string]: Option };
